module.exports = __webpack_public_path__ + "static/media/wmTrial-numbers-1.6456115c.mp3";